import Link from "@/v2-backoffice-client/components/link"
import LicenseAddOnTable from "@/v2-backoffice-client/license/addOns/LicenseAddOnTable"
import { useLicenseAddOnsQuery } from "@/v2-backoffice-client/license/addOns/license.addOns.query"
import {
  LICENSING_PATH,
  LICENSING_TABS_ID,
  LICENSING_VIEW_ADD_ONS,
} from "@/v2-backoffice-client/license/license.constants"

export type CustomerAddOnsProps = {
  customerId: number
  customerName?: string
}

// The customer panel's Add-ons section, right under the Licenses table and
// in the same shape: a heading with the way to the catalog, then the table
// of add-ons the customer holds, with Add add-on in its toolbar and Remove
// in the row menu. The one place add-ons are set. Same read as the Add-ons
// column in the Licenses table (same variables), so one change refreshes
// both.
function CustomerAddOns(props: CustomerAddOnsProps) {
  const { customerId, customerName } = props

  const { data, loading, error, refetch } = useLicenseAddOnsQuery({
    variables: { customerId },
  })
  const addOns = data?.getCustomerAddOns ?? []

  return (
    <section className="flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <h3 className="text-sm font-semibold">Add-ons</h3>
        {/* What an add-on is and what each unlocks is the catalog's job;
            this section only says which ones the customer has. */}
        <Link
          variant="muted"
          size="xs"
          iconSrc={null}
          to={`${LICENSING_PATH}?${LICENSING_TABS_ID}-tab=${LICENSING_VIEW_ADD_ONS}`}
          className="underline underline-offset-2"
        >
          What each add-on is: Licensing → Add-ons
        </Link>
      </div>
      <LicenseAddOnTable
        addOns={addOns}
        isLoading={loading}
        error={error}
        customerId={customerId}
        customerName={customerName}
        onRefresh={() => void refetch()}
      />
    </section>
  )
}

export default CustomerAddOns
